<template>
  <div class="select native-select">
    <select
      :value="value"
      :disabled="disabled"
      :[tabindexAttr]="tabindex"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @change="handleChange"
    >
      <option
        v-if="hasDefaultBlank"
        value=""
        disabled
        selected
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in visibleOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { isOptionVisible } from './helpers';

export default {
  name: 'NativeSelect',
  props: {
    value: { type: [String, Number, Boolean], default: '' },
    options: { type: Array, required: true },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    hasDefaultBlank: { type: Boolean, default: true },
    tabindex: { type: [Number, String], default: null },
  },
  computed: {
    visibleOptions() {
      return this.options.filter(isOptionVisible);
    },
    tabindexAttr() {
      return this.tabindex != null ? 'tabindex' : null;
    },
  },
  methods: {
    handleChange(event) {
      const rawValue = event.target.value;
      const match = this.options.find((option) => String(option.value) === rawValue);
      const value = match ? match.value : rawValue;

      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.native-select {
  display: block;

  select {
    width: 100%;
    display: block;
    border: #D1D5DB solid 1px;
    border-radius: 6px;
    min-height: 42px;
    box-shadow: none;
    background-color: #fff;

    &::placeholder { color: #6B7280; }
    option { color: black; }
    &:disabled { border: #D1D5DB solid 1px; }
  }
}
</style>
